import Vue from "vue";
import VueRx from "vue-rx";
import { APP_LOGGER } from "@/app/logger";

APP_LOGGER.debug("Install vue-rx", { VueRx });
Vue.use(VueRx);
